import { gql } from "@apollo/client"
import { ORDER_DETAIL_FRAG, ORDER_LIST_FRAG } from "./order.fragments.gql"

export const BULK_UPDATE_ORDERS = gql`
  mutation BulkUpdateOrders(
    $orders: [ID]
    $status: String
    $estimatedDelivery: DateTime
  ) {
    bulkUpdateOrder(
      ids: $orders
      status: $status
      estimatedDelivery: $estimatedDelivery
    ) {
      order {
        ...OrderDetailFrag
      }
    }
  }
  ${ORDER_DETAIL_FRAG}
`

export const ADD_TEMPORARY_ORDER = gql`
  mutation AddTemporaryOrder(
    $id: ID
    $orderItems: [OrderItemStockInput]!
    $pickupSlots: [OrderPickupSlotInput]
    $shippingMethod: String!
    $userId: ID
    $billingAddress: AddressInput
    $orderCategory: String
    $skipDms: Boolean
    $discountId: ID
    $customDiscountFlat: Float
    $customDiscountPercent: Float
  ) {
    addTemporaryOrder(
      id: $id
      orderItems: $orderItems
      pickupSlots: $pickupSlots
      shippingMethod: $shippingMethod
      userId: $userId
      billingAddress: $billingAddress
      orderCategory: $orderCategory
      skipDms: $skipDms
      discountId: $discountId
      customDiscountFlat: $customDiscountFlat
      customDiscountPercent: $customDiscountPercent
    ) {
      order {
        ...OrderDetailFrag
        __typename
      }
      __typename
    }
  }
  ${ORDER_DETAIL_FRAG}
`

export const ADD_UPDATE_ORDER_TRANSACTION = gql`
  mutation AddUpdateOrderTransaction(
    $amount: Float!
    $id: ID
    $attachment: MediaInput
    $orderId: ID!
    $paymentMethod: String
    $referenceId: String
    $status: String!
  ) {
    addUpdateOrderTransaction(
      amount: $amount
      id: $id
      attachment: $attachment
      orderId: $orderId
      paymentMethod: $paymentMethod
      referenceId: $referenceId
      status: $status
    ) {
      orderTransaction {
        id
        referenceId
        amount
        order {
          id
          trackingCode
          totalPaid
          paymentMethod
          paymentStatus
          transactions {
            id
            attachment {
              id
              url
            }
            amount
            status
            referenceId
          }
        }
      }
    }
  }
`

export const ADD_UPDATE_CONSOLIDATED_ORDER = gql`
  mutation AddUpdateConsolidatedOrder(
    $id: ID
    $date: Date!
    $orderFilter: OrderFilterInput
    $orderIds: [ID]
    $orderingDcId: ID!
    $placedInId: ID!
    $remark: String
    $shopId: ID
    $targetDcId: ID!
    $userId: ID!
    $orderItems: [OrderItemStockInput]
    $category: String!
  ) {
    addUpdateConsolidatedOrder(
      date: $date
      id: $id
      orderFilter: $orderFilter
      orderIds: $orderIds
      orderingDcId: $orderingDcId
      placedInId: $placedInId
      remark: $remark
      shopId: $shopId
      targetDcId: $targetDcId
      userId: $userId
      orderItems: $orderItems
      category: $category
    ) {
      order {
        ...OrderListFrag
      }
    }
  }
  ${ORDER_LIST_FRAG}
`

export const ADD_UPDATE_ORDER_TRANSACTIONS = gql`
  mutation AddUpdateOrderTransactions(
    $orderId: ID!
    $transactions: [OrderTransactionEntryInput]!
  ) {
    addUpdateOrderTransactions(orderId: $orderId, transactions: $transactions) {
      orderTransactions {
        id
        referenceId
        amount
        status
        order {
          id
          trackingCode
          totalPaid
          paymentStatus
        }
      }
    }
  }
`

export const SETTLE_MULTIPLE_ORDERS = gql`
  mutation SettleMultipleOrders(
    $orderIds: [ID]!
    $amount: Decimal!
    $paymentMethod: String!
    $aggregatorId: ID!
    $departmentId: ID!
    $attachment: MediaInput
  ) {
    multiOrderPaymentSettle(
      orderIds: $orderIds
      amount: $amount
      paymentMethod: $paymentMethod
      aggregatorId: $aggregatorId
      departmentId: $departmentId
      attachment: $attachment
    ) {
      paymentId
      orderTransactions {
        id
        amount
        attachment {
          id
          url
        }
        status
        order {
          id
        }
        settledForTransaction {
          id
        }
      }
    }
  }
`
